<template>
  <article id="settings__contact">
    <h1 class="heading">
      {{ $t("settings.CONTACT_DETAILS") }}
    </h1>
    <section class="settings__content">
      <aside class="settings__info">
        <p
          class="copy"
          v-html="$t('settings.CHANGE_EMAIL_INFO', { email: myProfile.email })"
        />
      </aside>
      <aside class="settings__info">
        <p class="copy">
          {{ $t("settings.NOTIFICATION_INFO") }}
        </p>
      </aside>
      <section class="input__group">
        <div class="input">
          <input
            id="chk__replies"
            type="checkbox"
            name="chk__replies"
            v-model="replies"
          >
          <label
            class="label__options"
            for="chk__replies"
          >{{
            $t("settings.COMMENT_REPLIES_ACCEPT")
          }}</label>
        </div>
      </section>
      <section class="form__controls">
        <SpinnerButton
          :button-id="'btn__email_settings'"
          :button-class="'btn__confirm'"
          :button-type="'submit'"
          :button-listener="onClickSubmitSettings"
          :button-text="$t('buttons.SAVE')"
        />
      </section>
    </section>
  </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SpinnerButton from "../global/SpinnerButton";

export default {
  name: "ContactDetails",
  components: {
    SpinnerButton,
  },
  data() {
    return {
      replies: true,
    };
  },
  created() {
    this.getMyPreferences();
  },
  computed: {
    ...mapGetters(["myProfile", "myPreferences"]),
  },
  methods: {
    ...mapActions(["getMyPreferences", "updateMyPreferences"]),
    onClickSubmitSettings() {
      const payload = {
        childComment: this.replies,
        dailyMail: true,
        weeklyMail: true,
        reaction: true,
      };

      this.updateMyPreferences(payload);
    },
  },
  watch: {
    myPreferences() {
      this.replies = this.myPreferences.childComment;
    },
  },
};
</script>
